import { getSessionData, signOut } from './authConfig.js'
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import { getUserAccountsSingleton } from '../userAccountsSingleton.service.js'

//Key constants
const CurrentAccountKey = 'currentAccount'
const RememberedAccountKey = 'rememberedAccountId_'
const FullViewKey = 'isFullView'
const FocusSearchEnabled = 'focusSearchEnabled'
const OrderTrackingKey = 'orderTracking'
//Session Managers
const setSessionState = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data))

  //Remember last sessionState for user logged out
  let username = getSessionData().loggedUser.id
  localStorage.setItem(RememberedAccountKey + username, data.id)
}
const getSessionState = (key) => {
  return JSON.parse(localStorage.getItem(key))
}
const removeSessionState = (key) => {
  localStorage.removeItem(key)
}

//Public session methods
export const setCurrentAccount = (data) => {
  setSessionState(CurrentAccountKey, data)
}
export const setFullViewState = (data) => {
  setSessionState(FullViewKey, data)
}
export const setFocusSearchEnabled = (data) => {
  setSessionState(FocusSearchEnabled, data)
}
export const setOrderTrackingState = (accountId, data) => {
  const orderTrackingByCustomerId = { accountId: accountId, data: data }
  setSessionState(OrderTrackingKey, orderTrackingByCustomerId)
}

export const getCurrentAccount = () => {
  const sessionState = getSessionState(CurrentAccountKey)
  return sessionState ? sessionState : {}
}
export const getCurrentFullViewState = () => {
  const sessionState = getSessionState(FullViewKey)
  return sessionState ? sessionState : false
}
export const getCurrentFocusSearchEnabled = () => {
  const sessionState = getSessionState(FocusSearchEnabled)
  return sessionState ? sessionState : false
}
export const getOrderTrackingState = (currentAccountId) => {
  const orderTrackingFromStorage = getSessionState(OrderTrackingKey)
  if (!orderTrackingFromStorage || orderTrackingFromStorage.accountId !== currentAccountId) {
    return null
  }
  return orderTrackingFromStorage.data
}
export const removeCurrentAccount = () => {
  removeSessionState(CurrentAccountKey)
}
export const getRememberedAccount = () => {
  let username = getSessionData().loggedUser.id
  return localStorage.getItem(RememberedAccountKey + username)
}
export const getSecurityFlags = () => {
  var userLogged = getSessionData().loggedUser

  if (userLogged.isWebGroupAccount) {
    return userLogged.securityFlags
  } else {
    if (getCurrentAccount() === null) {
      return null
    } else {
      return getCurrentAccount().securityFlags
    }
  }
}

//Return data
const AccountNotFoundError = -2
const Error = -1
const NoActionRequired = 0
const RefreshUX = 1
const RedirectChangeAccount = 2
const refreshCurrentAccount = async () => {
  let sessionData = getSessionData()
  let currentAccount = getCurrentAccount()
  let rememberedAccount = getRememberedAccount()
  let userAccounts = await getUserAccountsSingleton()

  if (sessionData === null || sessionData === undefined) return Error

  const isCurrentAccountOk =
    currentAccount !== undefined && currentAccount !== null && currentAccount.length !== 0
  const foundCurrentAccount = isCurrentAccountOk
    ? userAccounts.data.find((obj) => obj.id === currentAccount.id)
    : null
  const isFoundCurrentAccountOk = foundCurrentAccount !== undefined && foundCurrentAccount !== null

  if (isCurrentAccountOk && isFoundCurrentAccountOk) {
    if (currentAccount === foundCurrentAccount) return NoActionRequired

    setCurrentAccount(foundCurrentAccount)
    return RefreshUX
  }

  setCurrentAccount({})

  if (userAccounts.data.length === 0) return AccountNotFoundError

  if (userAccounts.data.length === 1) {
    setCurrentAccount(userAccounts.data[0])
    return RefreshUX
  }

  const isRememberedAccountOk = rememberedAccount !== undefined && rememberedAccount !== null
  const foundRememberedAccount = isRememberedAccountOk
    ? userAccounts.data.find((obj) => obj.id === rememberedAccount.id)
    : null
  const isFoundRememberedAccountOk =
    foundRememberedAccount !== undefined && foundRememberedAccount !== null

  if (isRememberedAccountOk && isFoundRememberedAccountOk) {
    setCurrentAccount(foundRememberedAccount)
    return RefreshUX
  }

  return RedirectChangeAccount
}
//Pass "this" as parameter
export const refreshCurrentAccountWrapperInFunctionalComponent = async (forceUpdate, props) => {
  let isValid = await refreshCurrentAccount()
  switch (isValid) {
    case AccountNotFoundError:
      swal({
        type: 'error',
        title: 'Error',
        text: 'No se ha encontrado una cuenta válida, por favor contacte al administrador',
        footer: '<a href>Será redireccionado al inicio de sesión</a>'
      }).then((result) => {
        signOut()
      })
      break
    case Error:
      swal({
        type: 'error',
        title: 'Error',
        text: 'Hay un error en el inicio de sesión'
      }).then((result) => {
        signOut()
      })
      break
    case NoActionRequired:
      break
    case RefreshUX:
      forceUpdate()
      break
    case RedirectChangeAccount:
      let pathName = window.location.href
      if (pathName.indexOf('accountchange') === -1) {
        //No estoy en account, ir
        console.warn('Redirect to accountChange')
        if (props && props.history) {
          props.history.push('/accountchange')
        }
      }
      break
    default:
      console.error('Internal error')
  }
}
export const refreshCurrentAccountWrapper = (system) => {
  refreshCurrentAccountWrapperInFunctionalComponent(
    system.forceUpdate.bind(system),
    system ? system.props : undefined
  )
}
